import React, { useCallback, useEffect, useState, useRef } from "react";
import PropTypes from "prop-types";
import "./style.css";

const MultiRangeSlider = ({ min, max, onChange, filter }) => {
  const [minVal, setMinVal] = useState("0");
  const [maxVal, setMaxVal] = useState(filter === "user" ? "100" : "50");
  const minValRef = useRef(min);
  const maxValRef = useRef(max);
  const range = useRef(null);

  const getDisplayValue = useCallback((value) => {
    if (filter === "user") {
      return `${value}%`;
    } else {
      return `$${value.toLocaleString()}`;
    }
  }, [filter]);

  const getPercent = useCallback(
    (value) => Math.round(((value - min) / (max - min)) * 100),
    [min, max]
  );

  useEffect(() => {
    const minPercent = getPercent(minVal);
    const maxPercent = getPercent(maxValRef.current);

    if (range.current) {
      range.current.style.left = `${minPercent}%`;
      range.current.style.width = `${maxPercent - minPercent}%`;
    }
  }, [minVal, getPercent]);

  useEffect(() => {
    const minPercent = getPercent(minValRef.current);
    const maxPercent = getPercent(maxVal);

    if (range.current) {
      range.current.style.width = `${maxPercent - minPercent}%`;
    }
  }, [maxVal, getPercent]);

  useEffect(() => {
    onChange({ min: minVal, max: maxVal });
  }, [minVal, maxVal, onChange]);

  return (
    <div className="container">
      <input
        type="range"
        min={min}
        max={max}
        value={minVal}
        onChange={(event) => {
          const value = Math.min((event.target.value), maxVal - 1);
          setMinVal(value);
          minValRef.current = value;
        }}
        className="thumb thumb--left"
        style={{ zIndex: minVal > max - 100 && "5" }}
      />
      <input
        type="range"
        min={min}
        max={max}
        value={maxVal}
        onChange={(event) => {
          const value = Math.max((event.target.value), minVal + 1);
          setMaxVal(value);
          maxValRef.current = value;
        }}
        className="thumb thumb--right"
      />

      <div className="slider">
        <div className="slider__track" />
        <div ref={range} className="slider__range" />
        <div className="slider__left-value">
          {getDisplayValue(minVal)}
        </div>
        <div className="slider__right-value">
          {getDisplayValue(maxVal)}
        </div>
      </div>
    </div>
  );
};

MultiRangeSlider.propTypes = {
  min: PropTypes.number.isRequired,
  max: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  filter: PropTypes.oneOf(["projects", "user"]).isRequired,
};

export default MultiRangeSlider;
